import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  OnInit,
  AfterViewInit,
  OnChanges,
  ViewChild,
  HostListener, SimpleChanges
} from '@angular/core';
import { Reservations } from '../../interfaces/reservations';
import { WordpressService } from '../../services/wordpress.service';
import {SectionMetadata} from '../../interfaces/metadata';
import {MetaDataService} from '../../services/metadata.service';
declare let $: any; // for jquery and jquery ui

@Component({
  selector: 'app-reservations-overlay',
  templateUrl: './reservations-overlay.component.html',
  styleUrls: ['./reservations-overlay.component.scss']
})
export class ReservationsOverlayComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() reservationsOpen: boolean;
  @Output() close = new EventEmitter<boolean>();
  @ViewChild('date') date: ElementRef;
  @ViewChild('additional') additional: ElementRef;
  reservations: Reservations;
  hourOptions: { value: string; name: string }[];
  peopleOptions: { value: string; name: string }[];
  results: { date: string; hour: string; numPeople: string } = {
    date: null,
    hour: null,
    numPeople: null
  };
  url: string;
  desktop: boolean;
  reservationsMetadata: SectionMetadata;
  focusStart;
  focusEnd;

  constructor(
    private wp: WordpressService,
    private el: ElementRef,
    private mds: MetaDataService
  ) {
    this.wp.getReservations().subscribe(res => {
      this.reservations = res ? res.acf : null;
      this.setPeopleOptions();
      this.reservationsMetadata = this.reservations && this.reservations.sections ?
        this.reservations.sections.find(section => section.section_slug === 'reservations') : null;

      this.setMetaData();
    });
    this.checkDesktop();
  }

  focusOutFunction(r) {
    if (r === 'start') {
      this.additional.nativeElement.focus();
    } else {
      this.date.nativeElement.focus();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkDesktop();
  }

  setMetaData() {
    if (this.reservationsMetadata && this.reservationsOpen) {
      this.mds.setMetaData(this.reservationsMetadata);
    }
  }

  checkDesktop() {
    this.desktop = window.innerWidth > 767 ? true : false;
  }


  setUrl() {
    let _url = 'https://www.opentable.com/restaurant/profile/1034467/reserve?restref=1034467&';

    if (this.results.date) {
      _url += `datetime=${this.results.date}`;
    }
    if (this.results.hour) {
      _url += this.results.hour;
    }
    if (this.results.numPeople) {
      _url += `&covers=${this.results.numPeople}`;
    }
    this.url = _url;
  }

  updateResults(option, value) {
    this.results[option] = value;
    this.setUrl();
  }

  setPeopleOptions() {
    const options = [
      { value: '1', name: '1' },
      { value: '2', name: '2' },
      { value: '3', name: '3' },
      { value: '4', name: '4' },
      { value: '5', name: '5' },
      { value: '6', name: '6' },
      { value: '7', name: '7' },
      { value: '8', name: '8' },
      { value: '9', name: '9' },
      { value: '10', name: '10' }
    ];

    this.peopleOptions = options;
  }

  formatDate(date) {
    const today = new Date(date);
    this.setHourOptions();
    const dd =
      today.getDate() < 10 ? `0${today.getDate()}` : `${today.getDate()}`;
    const mm =
      today.getMonth() + 1 < 10
        ? `0${today.getMonth() + 1}`
        : `${today.getMonth() + 1}`;
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }

  setHourOptions() {
    this.results.hour = 'T17:30';
    this.hourOptions = [
      { value: 'T10:00', name: '10 : 00 am' },
      { value: 'T10:30', name: '10 : 30 am' },
      { value: 'T11:00', name: '11 : 00 am' },
      { value: 'T11:30', name: '11 : 30 am' },
      { value: 'T12:00', name: '12 : 00 am' },
      { value: 'T12:30', name: '12 : 30 am' },
      { value: 'T01:00', name: '1 : 00 pm' },
      { value: 'T01:30', name: '1 : 30 pm' },
      { value: 'T02:00', name: '2 : 00 pm' },
      { value: 'T17:30', name: '5 : 30 pm' },
      { value: 'T18:00', name: '6 : 00 pm' },
      { value: 'T18:30', name: '6 : 30 pm' },
      { value: 'T19:00', name: '7 : 00 pm' },
      { value: 'T19:30', name: '7 : 30 pm' },
      { value: 'T20:00', name: '8 : 00 pm' },
      { value: 'T20:30', name: '8 : 30 pm' },
      { value: 'T21:00', name: '9 : 00 pm' },
      { value: 'T21:30', name: '9 : 30 pm' },
      { value: 'T22:00', name: '10 : 00 pm' },
    ];
  }

  ngOnInit() {
    this.onResize();

    // Default values
    this.results.hour = 'T17:30';
    this.results.numPeople = '2';
  }

  ngAfterViewInit() {
    // Initialize Date Picker && set default date to today
    const $date = $('[data-date]', this.el.nativeElement).datepicker({
      minDate: 0,
      onSelect: event => {
        this.updateResults('date', this.formatDate(event));
      }
    });
    const todayDate = new Date();
    $date.datepicker('setDate', todayDate);
    this.results.date = this.formatDate(todayDate);

    // Set button url with initial values
    setTimeout(() => {
      this.setUrl();
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.reservationsOpen && changes.reservationsOpen.currentValue) {
      // Set reservations metadata override
      this.setMetaData();
      this.date.nativeElement.focus();
      console.log('here')
    }
  }

}
